/**
 * Splash Route - Landing page
 *
 * Auto-navigates after 3.6 seconds based on:
 * - Authenticated (mvv exists) → HOME
 * - Has mvv_ts (previously signed out) → SIGN IN
 * - No mvv or mvv_ts → Show buttons (stay on splash)
 */

import PubSub from 'pubsub-js';
import AppBroadcast from '../../../../shared/appBroadcast.js';
import { FEATURE_FLAGS } from '../../../../shared/featureFlags.js';

export function render() {
  return `
    <div class="auth-container">
      <div class="auth-left">
        <div class="splash-content">
          <h1>StreamSyncEngage</h1>
          <p class="tagline">Real-time messaging and account management platform</p>

          <div class="splash-loader" id="splash-loader">
            <div class="spinner"></div>
            <p class="loading-text">Loading...</p>
          </div>

          <div class="splash-actions" id="splash-actions" style="display: none;">
            <button class="btn btn-primary" data-route="signin">
              Sign In
            </button>
            <button class="btn btn-secondary" data-route="signup">
              Sign Up
            </button>
          </div>
        </div>
      </div>

      <div class="auth-right">
        <section class="auth-right__vect">
        <!-- Diagram background via CSS -->
        </section>
      </div>
    </div>

    <style>
      .auth-container {
        display: grid;
        grid-template-columns: 1fr 1fr;
        min-height: 100vh;
        background: var(--color-gray-100);
      }

      @media (orientation: portrait) {
        .auth-container {
          grid-template-columns: 1fr;
          grid-template-rows: auto auto;
        }
      }

      .auth-left {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        padding: 3rem 2rem;
        background: var(--color-gray-200);
      }

      .auth-right { display: block; padding: 16px; }
      .auth-right__vect {
        height: 100%;
        background-image: var(--see-diagram-hex);
        background-size: contain;
        background-position: center;
        background-repeat: no-repeat;
      }

      @media (orientation: portrait) {
        .auth-right {
          min-height: 300px;
        }
      }

      .splash-content {
        text-align: center;
        max-width: 500px;
        width: 100%;
      }

      .splash-content h1 {
        font-size: 3rem;
        margin-bottom: 1rem;
        font-weight: 700;
        color: var(--color-gray-900);
      }

      .tagline {
        font-size: 1.2rem;
        margin-bottom: 3rem;
        color: var(--color-gray-700);
      }

      .splash-loader {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 1.5rem;
      }

      .spinner {
        width: 50px;
        height: 50px;
        border: 4px solid var(--color-gray-300);
        border-top-color: var(--color-primary-600);
        border-radius: 50%;
        animation: spin 1s linear infinite;
      }

      @keyframes spin {
        to { transform: rotate(360deg); }
      }

      .loading-text {
        font-size: 1rem;
        color: var(--color-gray-600);
        animation: pulse 2s ease-in-out infinite;
      }

      @keyframes pulse {
        0%, 100% { opacity: 0.6; }
        50% { opacity: 1; }
      }

      .splash-actions {
        display: flex;
        gap: 1rem;
        justify-content: center;
        margin-top: 2rem;
      }

      .btn {
        padding: 12px 24px;
        border: none;
        border-radius: 6px;
        font-size: 1rem;
        font-weight: 600;
        cursor: pointer;
        transition: all 0.3s ease;
      }

      .btn-primary {
        background: var(--color-primary-600);
        color: white;
      }

      .btn-primary:hover {
        background: var(--color-primary-700);
        transform: translateY(-2px);
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
      }

      .btn-secondary {
        background: transparent;
        color: var(--color-gray-700);
        border: 2px solid var(--color-gray-400);
      }

      .btn-secondary:hover {
        background: var(--color-gray-300);
        border-color: var(--color-gray-500);
        transform: translateY(-2px);
      }
    </style>
  `;
}

export function init() {
  console.log('[SplashRoute] Initialized - checking authentication state in 3.6 seconds...');

  // Check authentication after 3.6 seconds
  setTimeout(() => {
    const mvvToken = localStorage.getItem(FEATURE_FLAGS.FF_SSE_LS_TOKEN);
    const mvvTs = localStorage.getItem('mvv_ts');

    console.log('[SplashRoute] localStorage check:', {
      hasMvvToken: !!mvvToken,
      hasMvvTs: !!mvvTs
    });

    const loader = document.getElementById('splash-loader');
    const actions = document.getElementById('splash-actions');

    if (mvvToken) {
      // User has auth token → navigate to HOME
      console.log('[SplashRoute] Auth token found → HOME');
      PubSub.publish(AppBroadcast.ROUTE_NAV, { route: 'home' });
    } else if (mvvTs) {
      // Has mvv_ts (previously signed out) → navigate to SIGN IN
      console.log('[SplashRoute] Previous session detected (mvv_ts exists) → SIGN IN');
      PubSub.publish(AppBroadcast.ROUTE_NAV, { route: 'signin' });
    } else {
      // No mvv or mvv_ts → Show buttons and stay on splash
      console.log('[SplashRoute] New user (no session history) → Showing buttons');
      if (loader) loader.style.display = 'none';
      if (actions) actions.style.display = 'flex';

      // Attach button click handlers to publish ROUTE_NAV
      const buttons = document.querySelectorAll('[data-route]');
      buttons.forEach(btn => {
        btn.addEventListener('click', () => {
          const route = btn.getAttribute('data-route');
          console.log(`[SplashRoute] Button clicked - navigating to: ${route}`);
          PubSub.publish(AppBroadcast.ROUTE_NAV, { route });
        });
      });
    }
  }, 4000); // 4 seconds 
}
